import { DebugEvent } from 'core/DebugEvent';

interface SidePagingClickEventInterface {
	index: number;
	targetSelector: string;
}

export class SidePagingClickEvent extends DebugEvent implements SidePagingClickEventInterface {
	public static eventName: string = 'SIDE_PAGING_CLICK_EVENT';
	public index: number;
	public targetSelector: string;

	constructor(parameters: SidePagingClickEventInterface) {
		super(parameters);
	}
}
